import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      email: '',
      permissions: {},
      name: '',
      type: '',
      lang: 1
    },
    systemMessages: {
      unreadCount: 0
    }
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', {});
    }
  },
  mutations: {
    setUserID (state, id) {
      Vue.set(state.user, 'id', parseInt(id, 10));
    },
    setUserName (state, name) {
      Vue.set(state.user, 'name', name);
    },
    setUserEmail (state, email) {
      Vue.set(state.user, 'email', email);
    },
    setUserPermissions (state, permissions) {
      Vue.set(state.user, 'permissions', JSON.parse(JSON.stringify(permissions)));
    },
    setUserType (state, type) {
      Vue.set(state.user, 'type', type);
    },
    setUserLang (state, langID) {
      if (langID) {
        Vue.set(state.user, 'lang', langID);
      } else {
        Vue.set(state.user, 'lang', 1);
      }
    },
    setUnreadSystemMessagesCount (state, count) {
      Vue.set(state.systemMessages, 'unreadCount', parseInt(count, 10) || 0);
    }
  },
  getters: {
    getUserID: (state) => state.user.id,
    getUserName: (state) => state.user.name,
    getUserEmail: (state) => state.user.email,
    getUserPermission: (state) => (permission) => !!state.user.permissions[permission],
    getUserType: (state) => state.user.type,
    getUserLang: (state) => state.user.lang,
    getUnreadSystemMessagesCount: (state) => state.systemMessages.unreadCount
  }
});
